<template>
  <el-card>
    <div class="blocked_logs_page">
    <h1>直播间用户停留时长分布</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="isPay"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isPays"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
       <CustomBar 
        element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				v-loading="loing"
				:options="barOptions"
				class="bar"
				width="100%"></CustomBar>
    </el-row>
     
  </div>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import CustomBar from '@/components/CustomBar'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  components: {
    CustomBar
  },
  data() {
    return {
      login1: false,
      loing: false,
      barOptions: {
        xAxis: {
          name: '时间',
          type: 'category',
          data: [
            '0-30s',
            '30s-1min',
            '1-5min',
            '5-10min',
            '10-20min',
            '20-40min',
            '40-60min',
            '1-2h',
            '2-4h',
            '4-8h',
            '8-12h',
            '12h>'
          ]
        },
        yAxis: {
          name: '人数',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    color: 'black',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      },
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: 0,
      userTypes: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        },
        
      ],
      isPay: 0,
      isPays: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '非付费用户',
          value: 1
        },
        {
          label: '付费用户',
          value: 2
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_roomUserOnlineStat,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          startDate: this.platformData[0],
          endDate: this.platformData[1],
          channel: this.curChannel.selectValue,
          countryCode: this.country,
          lang: this.language,
          isPay:this.isPay,
          userType: this.userType,
        }
      })
      if (res !== null) {
        this.login1 = false
        this.barOptions.series[0].data = res.data.data
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_roomUserOnlineStat_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          startDate: this.platformData[0],
          endDate: this.platformData[1],
          channel: this.curChannel.selectValue,
          countryCode: this.country,
          lang: this.language,
          isPay:this.isPay,
          userType: this.userType,
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '直播间用户停留时长分布' + '')
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
